<template>
  <div>
    <img style="width: 294px;" :src="require('../../assets/products/D/img_D1.8.png')" alt="">
    <h2>Product Description</h2>
    <p>Single-phase series type voltage transformers, which meet the requirements of  IEC 60044-1 :2003 and  IEC186 voltage transformers of International Electrotechnical Commission. They are used for voltage, energy measurement and relay protection of 110kV neutral point effective grounding system.</p>
    <h2>Main Technical Parameters</h2>
    <p>
      Rated  voltage:  110000/√3 V <br>
      Rated  primary  voltage: 100/√3 V <br>
      Winding  rated  voltage: 100 V <br>
      Residual voltage winding voltage: 100V <br>
      Rated Frequency: 50/60 Hz <br>
      Phase: Single Phase <br>
      Winding connection group label: 1 / 1 / 1-12-12 <br>
      Maximum voltage of equipment: 126kV <br>
      Accuracy level and rated output <br>
      See Table 1 for accuracy level and rated output of secondary winding.
    </p>
    <img :src="require('../../assets/products/D/pd_D1.8.1.png')" alt="">
    <img class="seconds" :src="require('../../assets/products/D/pd_D1.8.2.png')" alt="">
    <img :src="require('../../assets/products/D/pd_D1.8.3.png')" alt="">
    <p>
      • Error Limit of Residual Voltage Winding <br>When any voltage between the rated frequency and the primary voltage is 5-150% of the rated voltage, the residual voltage winding is connected with any value load between 75-300va, and the secondary winding is connected with any load between 125-500va, the residual voltage winding error shall not exceed the limit listed in Table 3. Under the 2% rated voltage, the voltage error and phase difference shall not exceed twice the limit listed in Table 3. <br> <br>• Temperature Rise Limit <br>When the secondary winding is connected with 2000VA limit load, tapping factor is any value between 0.8 (lagging) and 1, and the primary voltage is 1.2 times of the rated primary voltage for long-term operation, the temperature rise of each part of the voltage transformer shall not exceed the following provisions. <br> <br>• Winding 65K (resistance method) <br>• Oil level 55k (thermometer method) <br>After the normal temperature rise test reaches a stable state, when the secondary winding is connected with a load of 500VA and the residual voltage winding is connected with a load of 300VA, apply 1.5 times of the rated voltage to the primary winding. For 30s, the winding temperature rise shall not exceed 75K. <br>Insulation Level of N-terminal of Secondary Winding and Primary Winding. At room temperature, the insulation resistance between secondary winding, residual voltage winding and to ground shall not be less than 100m Ω, primary N-terminal to secondary winding, residual winding and underground shall not be less than 500m Ω. <br>The power frequency withstand voltage of the N-terminal of the primary winding to the residual voltage winding of the secondary winding and the ground for 1 min is 5kV. <br>The power frequency withstand voltage between secondary winding, residual voltage winding and to the ground for 1min is 3KV. <br> <br>• Insulation Level of Primary Winding <br>Induction withstand voltage 200kV; <br>Lightning impulse full wave withstand voltage 480kV; (peak value) <br>Lightning impulse cut-off withstand voltage (internal insulation) 530kV (peak value) <br>The breakdown voltage of transformer oil shall not be lower than 45kv, TGδ under 90 ℃, 2KV shall not be greater than 0.4% water content ≤20ppm, C2H2 = 0. <br>Dielectric loss rate (TGδ). <br>Overall ≤ 2% <br>Support ≤ 5% <br> <br>• The measurement conditions are: temperature + 10 ~ 30 ℃, relative humidity no more than 60%. <br>• Partial Discharge Level <br>Apparent discharge of transformer shall not exceed 5pc.
    </p>
  </div>
</template>

<script>
export default {
  name: "D1.8"
}
</script>

<style scoped lang="scss">

h2{
  margin-top:50px;
  color:$blue;
  @include contents;
  @include mobile{
    width: calc(100% - 40px);
  }
}
p{
  @include contents;
  text-align: left;
  width: 700px;
  margin:10px auto 0;
  @include mobile{
    width: calc(100% - 40px);
    padding:0 20px;
  }
}
img{
  margin:10px 0;
  @include mobile{
    width: calc(100% - 40px);
    padding:0 20px;
  }
}
img.seconds{
  margin-top: 140px;
  @include mobile{
    margin-top: 40px;
  }
}
</style>
